import { render, staticRenderFns } from "./AddTeamMemberForm.vue?vue&type=template&id=af6510cc&lang=pug&"
import script from "./AddTeamMemberForm.vue?vue&type=script&lang=ts&"
export * from "./AddTeamMemberForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports